import { render, staticRenderFns } from "./ShopApply.vue?vue&type=template&id=572462c3&scoped=true"
import script from "./ShopApply.vue?vue&type=script&lang=js"
export * from "./ShopApply.vue?vue&type=script&lang=js"
import style0 from "./ShopApply.vue?vue&type=style&index=0&id=572462c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572462c3",
  null
  
)

export default component.exports